export const summarydashboardsteps = () =>  [
  {
    target: '[data-tour="summary-filter"]',
    title: 'Filters',
    content:
      'Filter dashboard statistics based on your selected criteria.',
    disableBeacon: true,
  },
  {
    target: '[data-tour="summary-cards"]',
    title: 'Quick Statistics',
    content:
      'These cards show recently created, updated, completed and due work items.',
       disableBeacon: true,
  },
  {
    target: '[data-tour="status-chart"]',
    title: 'Task Status Overview',
    content:
      'Visualize how work items are distributed across different statuses.',
       disableBeacon: true,
  },
  {
    target: '[data-tour="priority-chart"]',
    title: 'Priority Overview',
    content:
      'Track work items grouped by their priority levels.',
       disableBeacon: true,
  },
  {
    target: '[data-tour="worktype-chart"]',
    title: 'Work Type Distribution',
    content:
      'See the percentage breakdown of different work item types, such as Stories, Tasks, Bugs, and Epics, to understand your project composition.',
       disableBeacon: true,
  },
  {
    target: '[data-tour="epic-progress"]',
    title: 'Epic Progress',
    content:
      'Track the completion progress of each epic to understand how major features and initiatives are advancing.',
       disableBeacon: true,
  },
  {
    target: '[data-tour="team-distribution"]',
    title: 'Team Task Distribution',
    content:
      'View how work items are distributed among team members, helping you monitor workload balance and resource allocation.',
       disableBeacon: true,
  },
];